import { combineReducers } from '@reduxjs/toolkit'

import { alertManualsReducer as alertManuals } from './alertManuals/reducer'
import { businessTypesReducer as businessTypes } from './businessTypes/reducer'
import { cfrDefaultParamsReducer as cfrDefaultParams } from './cfrDefaultParams/reducer'
import { cfrGroupsReducer as cfrGroups } from './cfrGroups/reducer'
import { cfrLogsReducer as cfrLogs } from './cfrLogs/reducer'
import { cognitiveSettingsReducer as cognitiveSettings } from './cognitiveSettings/reducer'
import { configReducer as config } from './config/reducer'
import { dataSourceFieldsReducer as dataSourceFields } from './dataSourceFields/reducer'
import { fieldsReducer as fields } from './fields/reducer'
import { granularitiesReducer as granularities } from './granularities/reducer'
import { groupsReducer as groups } from './groups/reducer'
import { languagesReducer as languages } from './languages/reducer'
import { manualsReducer as manuals } from './manuals/reducer'
import { mlSettingsReducer as mlSettings } from './mlSettings/reducer'
import { profileReducer as profile } from './profile/reducer'
import { projectsReducer as projects } from './projects/reducer'
import { promoConstraintsReducer as promoConstraints } from './promoConstraints/reducer'
import { promoGroupsReducer as promoGroups } from './promoGroups/reducer'
import { promoHierarchyLevelsReducer as promoHierarchyLevels } from './promoHierarchyLevels/reducer'
import { promoLogsReducer as promoLogs } from './promoLogs/reducer'
import { promoOptimizerSettingsReducer as promoOptimizerSettings } from './promoOptimizerSettings/reducer'
import { promoPeriodsReducer as promoPeriods } from './promoPeriods/reducer'
import { promoTargetVariablesReducer as promoTargetVariables } from './promoTargetVariables/reducer'
import { pythonTypesReducer as pythonTypes } from './pythonTypes/reducer'
import { rtmGroupsReducer as rtmGroups } from './rtmGroups/reducer'
import { rtmParametersReducer as rtmParameters } from './rtmParameters/reducer'
import { templatesReducer as templates } from './templates/reducer'
import { tetrisDefaultPricesReducer as tetrisDefaultPrices } from './tetrisDefaultPrices/reducer'
import { tetrisGroupsReducer as tetrisGroups } from './tetrisGroups/reducer'
import { tetrisLogsReducer as tetrisLogs } from './tetrisLogs/reducer'
import { uiReducer as ui } from './ui/reducer'
import { usersReducer as users } from './users/reducer'

export const rootReducer = combineReducers({
  profile,
  ui,
  users,
  groups,
  projects,
  granularities,
  templates,
  businessTypes,
  fields,
  promoConstraints,
  promoGroups,
  promoLogs,
  promoTargetVariables,
  promoHierarchyLevels,
  promoOptimizerSettings,
  promoPeriods,
  pythonTypes,
  languages,
  mlSettings,
  cognitiveSettings,
  dataSourceFields,
  rtmGroups,
  rtmParameters,
  tetrisGroups,
  tetrisDefaultPrices,
  tetrisLogs,
  cfrGroups,
  cfrDefaultParams,
  config,
  cfrLogs,
  manuals,
  alertManuals,
})

export type RootState = ReturnType<typeof rootReducer>
